// Захардкоженная таблица аэропортов: IATA -> таймзона (IANA) + город.
// Чистый модуль без внешних зависимостей (кроме типов).
// Если код или таймзона аэропорта вызывают сомнение — он НЕ включён в таблицу.

export interface AirportInfo {
  tz: string;
  city: string;
  name?: string;
}

export const IATA: Readonly<Record<string, AirportInfo>> = {
  // Кавказ / Беларусь / Кипр — обязательные из демо
  LCA: { tz: 'Asia/Nicosia', city: 'Larnaca', name: 'Larnaca International' },
  EVN: { tz: 'Asia/Yerevan', city: 'Yerevan', name: 'Zvartnots' },
  MSQ: { tz: 'Europe/Minsk', city: 'Minsk', name: 'Minsk National' },
  KUT: { tz: 'Asia/Tbilisi', city: 'Kutaisi', name: 'David the Builder Kutaisi' },
  TBS: { tz: 'Asia/Tbilisi', city: 'Tbilisi', name: 'Tbilisi International' },
  BUS: { tz: 'Asia/Tbilisi', city: 'Batumi', name: 'Batumi International' },

  // UK / Ireland
  LHR: { tz: 'Europe/London', city: 'London', name: 'Heathrow' },
  LGW: { tz: 'Europe/London', city: 'London', name: 'Gatwick' },
  STN: { tz: 'Europe/London', city: 'London', name: 'Stansted' },
  MAN: { tz: 'Europe/London', city: 'Manchester' },
  EDI: { tz: 'Europe/London', city: 'Edinburgh' },
  DUB: { tz: 'Europe/Dublin', city: 'Dublin' },

  // Франция
  CDG: { tz: 'Europe/Paris', city: 'Paris', name: 'Charles de Gaulle' },
  ORY: { tz: 'Europe/Paris', city: 'Paris', name: 'Orly' },

  // Бенелюкс
  AMS: { tz: 'Europe/Amsterdam', city: 'Amsterdam' },
  BRU: { tz: 'Europe/Brussels', city: 'Brussels' },

  // Германия
  FRA: { tz: 'Europe/Berlin', city: 'Frankfurt' },
  MUC: { tz: 'Europe/Berlin', city: 'Munich' },
  BER: { tz: 'Europe/Berlin', city: 'Berlin' },

  // Швейцария
  ZRH: { tz: 'Europe/Zurich', city: 'Zurich' },
  GVA: { tz: 'Europe/Zurich', city: 'Geneva' },
  BSL: { tz: 'Europe/Zurich', city: 'Basel' },

  // Австрия / Чехия
  VIE: { tz: 'Europe/Vienna', city: 'Vienna' },
  PRG: { tz: 'Europe/Prague', city: 'Prague' },

  // Польша
  WAW: { tz: 'Europe/Warsaw', city: 'Warsaw' },
  KRK: { tz: 'Europe/Warsaw', city: 'Krakow' },
  WMI: { tz: 'Europe/Warsaw', city: 'Warsaw', name: 'Modlin' },
  GDN: { tz: 'Europe/Warsaw', city: 'Gdansk' },
  POZ: { tz: 'Europe/Warsaw', city: 'Poznan' },
  WRO: { tz: 'Europe/Warsaw', city: 'Wroclaw' },

  // Венгрия
  BUD: { tz: 'Europe/Budapest', city: 'Budapest' },

  // Румыния
  OTP: { tz: 'Europe/Bucharest', city: 'Bucharest' },
  TSR: { tz: 'Europe/Bucharest', city: 'Timisoara' },
  CLJ: { tz: 'Europe/Bucharest', city: 'Cluj-Napoca' },
  IAS: { tz: 'Europe/Bucharest', city: 'Iasi' },

  // Болгария
  SOF: { tz: 'Europe/Sofia', city: 'Sofia' },
  VAR: { tz: 'Europe/Sofia', city: 'Varna' },
  BOJ: { tz: 'Europe/Sofia', city: 'Burgas' },

  // Турция
  IST: { tz: 'Europe/Istanbul', city: 'Istanbul' },
  SAW: { tz: 'Europe/Istanbul', city: 'Istanbul', name: 'Sabiha Gokcen' },
  AYT: { tz: 'Europe/Istanbul', city: 'Antalya' },
  ESB: { tz: 'Europe/Istanbul', city: 'Ankara' },
  ADB: { tz: 'Europe/Istanbul', city: 'Izmir' },

  // Греция
  ATH: { tz: 'Europe/Athens', city: 'Athens' },
  SKG: { tz: 'Europe/Athens', city: 'Thessaloniki' },

  // Испания
  MAD: { tz: 'Europe/Madrid', city: 'Madrid' },
  BCN: { tz: 'Europe/Madrid', city: 'Barcelona' },
  PMI: { tz: 'Europe/Madrid', city: 'Palma de Mallorca' },
  AGP: { tz: 'Europe/Madrid', city: 'Malaga' },
  VLC: { tz: 'Europe/Madrid', city: 'Valencia' },
  ALC: { tz: 'Europe/Madrid', city: 'Alicante' },
  TFS: { tz: 'Atlantic/Canary', city: 'Tenerife' },
  LPA: { tz: 'Atlantic/Canary', city: 'Gran Canaria' },

  // Португалия
  LIS: { tz: 'Europe/Lisbon', city: 'Lisbon' },
  OPO: { tz: 'Europe/Lisbon', city: 'Porto' },

  // Италия
  FCO: { tz: 'Europe/Rome', city: 'Rome', name: 'Fiumicino' },
  MXP: { tz: 'Europe/Rome', city: 'Milan', name: 'Malpensa' },
  BGY: { tz: 'Europe/Rome', city: 'Milan', name: 'Bergamo' },
  VCE: { tz: 'Europe/Rome', city: 'Venice' },
  NAP: { tz: 'Europe/Rome', city: 'Naples' },

  // Скандинавия / Балтия
  CPH: { tz: 'Europe/Copenhagen', city: 'Copenhagen' },
  ARN: { tz: 'Europe/Stockholm', city: 'Stockholm' },
  OSL: { tz: 'Europe/Oslo', city: 'Oslo' },
  HEL: { tz: 'Europe/Helsinki', city: 'Helsinki' },
  RIX: { tz: 'Europe/Riga', city: 'Riga' },
  TLL: { tz: 'Europe/Tallinn', city: 'Tallinn' },
  VNO: { tz: 'Europe/Vilnius', city: 'Vilnius' },

  // Балканы
  TIA: { tz: 'Europe/Tirane', city: 'Tirana' },
  SKP: { tz: 'Europe/Skopje', city: 'Skopje' },
  PRN: { tz: 'Europe/Belgrade', city: 'Pristina' },
  BEG: { tz: 'Europe/Belgrade', city: 'Belgrade' },
  ZAG: { tz: 'Europe/Zagreb', city: 'Zagreb' },
  SPU: { tz: 'Europe/Zagreb', city: 'Split' },
  DBV: { tz: 'Europe/Zagreb', city: 'Dubrovnik' },
  LJU: { tz: 'Europe/Ljubljana', city: 'Ljubljana' },
  SJJ: { tz: 'Europe/Sarajevo', city: 'Sarajevo' },
  TGD: { tz: 'Europe/Podgorica', city: 'Podgorica' },
  TIV: { tz: 'Europe/Podgorica', city: 'Tivat' },

  // Молдова / Украина
  KIV: { tz: 'Europe/Chisinau', city: 'Chisinau' },
  IEV: { tz: 'Europe/Kyiv', city: 'Kyiv', name: 'Zhulyany' },
  KBP: { tz: 'Europe/Kyiv', city: 'Kyiv', name: 'Boryspil' },
  ODS: { tz: 'Europe/Kyiv', city: 'Odesa' },
  LWO: { tz: 'Europe/Kyiv', city: 'Lviv' },

  // Ближний Восток
  DXB: { tz: 'Asia/Dubai', city: 'Dubai' },
  AUH: { tz: 'Asia/Dubai', city: 'Abu Dhabi' },
  DOH: { tz: 'Asia/Qatar', city: 'Doha' },
  KWI: { tz: 'Asia/Kuwait', city: 'Kuwait City' },
  RUH: { tz: 'Asia/Riyadh', city: 'Riyadh' },
  JED: { tz: 'Asia/Riyadh', city: 'Jeddah' },
  TLV: { tz: 'Asia/Jerusalem', city: 'Tel Aviv' },
  GYD: { tz: 'Asia/Baku', city: 'Baku' },

  // Центральная Азия
  TAS: { tz: 'Asia/Tashkent', city: 'Tashkent' },
  ALA: { tz: 'Asia/Almaty', city: 'Almaty' },
  NQZ: { tz: 'Asia/Almaty', city: 'Astana' },
  FRU: { tz: 'Asia/Bishkek', city: 'Bishkek' },

  // Северная Америка
  JFK: { tz: 'America/New_York', city: 'New York', name: 'JFK' },
  EWR: { tz: 'America/New_York', city: 'Newark' },
  LGA: { tz: 'America/New_York', city: 'New York', name: 'LaGuardia' },
  BOS: { tz: 'America/New_York', city: 'Boston' },
  IAD: { tz: 'America/New_York', city: 'Washington', name: 'Dulles' },
  DCA: { tz: 'America/New_York', city: 'Washington', name: 'National' },
  ATL: { tz: 'America/New_York', city: 'Atlanta' },
  ORD: { tz: 'America/Chicago', city: 'Chicago', name: "O'Hare" },
  DFW: { tz: 'America/Chicago', city: 'Dallas' },
  DEN: { tz: 'America/Denver', city: 'Denver' },
  LAX: { tz: 'America/Los_Angeles', city: 'Los Angeles' },
  SFO: { tz: 'America/Los_Angeles', city: 'San Francisco' },
  SEA: { tz: 'America/Los_Angeles', city: 'Seattle' },
  LAS: { tz: 'America/Los_Angeles', city: 'Las Vegas' },
  MIA: { tz: 'America/New_York', city: 'Miami' },
  MCO: { tz: 'America/New_York', city: 'Orlando' },
  PHX: { tz: 'America/Phoenix', city: 'Phoenix' },
  YYZ: { tz: 'America/Toronto', city: 'Toronto' },
  YUL: { tz: 'America/Toronto', city: 'Montreal' },
  YVR: { tz: 'America/Vancouver', city: 'Vancouver' },
  MEX: { tz: 'America/Mexico_City', city: 'Mexico City' },

  // Южная Америка
  GRU: { tz: 'America/Sao_Paulo', city: 'Sao Paulo' },
  EZE: { tz: 'America/Argentina/Buenos_Aires', city: 'Buenos Aires' },
  BOG: { tz: 'America/Bogota', city: 'Bogota' },
  LIM: { tz: 'America/Lima', city: 'Lima' },
  SCL: { tz: 'America/Santiago', city: 'Santiago' },

  // Азия-Тихоокеанский регион
  NRT: { tz: 'Asia/Tokyo', city: 'Tokyo', name: 'Narita' },
  HND: { tz: 'Asia/Tokyo', city: 'Tokyo', name: 'Haneda' },
  KIX: { tz: 'Asia/Tokyo', city: 'Osaka' },
  ICN: { tz: 'Asia/Seoul', city: 'Seoul' },
  PEK: { tz: 'Asia/Shanghai', city: 'Beijing' },
  PVG: { tz: 'Asia/Shanghai', city: 'Shanghai', name: 'Pudong' },
  CAN: { tz: 'Asia/Shanghai', city: 'Guangzhou' },
  HKG: { tz: 'Asia/Hong_Kong', city: 'Hong Kong' },
  TPE: { tz: 'Asia/Taipei', city: 'Taipei' },
  SIN: { tz: 'Asia/Singapore', city: 'Singapore' },
  BKK: { tz: 'Asia/Bangkok', city: 'Bangkok' },
  KUL: { tz: 'Asia/Kuala_Lumpur', city: 'Kuala Lumpur' },
  CGK: { tz: 'Asia/Jakarta', city: 'Jakarta' },
  MNL: { tz: 'Asia/Manila', city: 'Manila' },
  HAN: { tz: 'Asia/Ho_Chi_Minh', city: 'Hanoi' },
  SGN: { tz: 'Asia/Ho_Chi_Minh', city: 'Ho Chi Minh City' },
  DEL: { tz: 'Asia/Kolkata', city: 'Delhi' },
  BOM: { tz: 'Asia/Kolkata', city: 'Mumbai' },
  BLR: { tz: 'Asia/Kolkata', city: 'Bengaluru' },
  MAA: { tz: 'Asia/Kolkata', city: 'Chennai' },
  HYD: { tz: 'Asia/Kolkata', city: 'Hyderabad' },
  CMB: { tz: 'Asia/Colombo', city: 'Colombo' },
  KTM: { tz: 'Asia/Kathmandu', city: 'Kathmandu' },
  SYD: { tz: 'Australia/Sydney', city: 'Sydney' },
  MEL: { tz: 'Australia/Melbourne', city: 'Melbourne' },
  BNE: { tz: 'Australia/Brisbane', city: 'Brisbane' },
  PER: { tz: 'Australia/Perth', city: 'Perth' },
  AKL: { tz: 'Pacific/Auckland', city: 'Auckland' },

  // Африка
  CAI: { tz: 'Africa/Cairo', city: 'Cairo' },
  CMN: { tz: 'Africa/Casablanca', city: 'Casablanca' },
  TUN: { tz: 'Africa/Tunis', city: 'Tunis' },
  ALG: { tz: 'Africa/Algiers', city: 'Algiers' },
  JNB: { tz: 'Africa/Johannesburg', city: 'Johannesburg' },
  CPT: { tz: 'Africa/Johannesburg', city: 'Cape Town' },
  NBO: { tz: 'Africa/Nairobi', city: 'Nairobi' },
  ADD: { tz: 'Africa/Addis_Ababa', city: 'Addis Ababa' },
  LOS: { tz: 'Africa/Lagos', city: 'Lagos' },

  // Россия
  SVO: { tz: 'Europe/Moscow', city: 'Moscow', name: 'Sheremetyevo' },
  DME: { tz: 'Europe/Moscow', city: 'Moscow', name: 'Domodedovo' },
  VKO: { tz: 'Europe/Moscow', city: 'Moscow', name: 'Vnukovo' },
  LED: { tz: 'Europe/Moscow', city: 'Saint Petersburg' },
  KZN: { tz: 'Europe/Moscow', city: 'Kazan' },
  AER: { tz: 'Europe/Moscow', city: 'Sochi' },
  MRV: { tz: 'Europe/Moscow', city: 'Mineralnye Vody' },
  OVB: { tz: 'Asia/Novosibirsk', city: 'Novosibirsk' },
  KGD: { tz: 'Europe/Kaliningrad', city: 'Kaliningrad' },
  IKT: { tz: 'Asia/Irkutsk', city: 'Irkutsk' },
  VVO: { tz: 'Asia/Vladivostok', city: 'Vladivostok' },
};

/** Возвращает IANA-таймзону аэропорта, '' если код неизвестен. */
export function lookupTz(iata: string): string {
  const info = IATA[iata.toUpperCase()];
  return info ? info.tz : '';
}

/** Возвращает город аэропорта, '' если код неизвестен. */
export function airportCity(iata: string): string {
  const info = IATA[iata.toUpperCase()];
  return info ? info.city : '';
}

/** Отсортированный список уникальных IANA-таймзон из таблицы — для UI-даталистов. */
export const KNOWN_TIMEZONES: readonly string[] = Array.from(
  new Set(Object.values(IATA).map((a) => a.tz))
).sort();

